import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSections } from './components/ProblemSections';
import { SolutionSections } from './components/SolutionSections';
import { Testimonials } from './components/Testimonials';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#FDF8F0] text-[#3D3631] font-sans selection:bg-[#D4654A]/20" data-id="element-0">
      <style data-id="element-1">{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&display=swap');
        
        body {
          font-family: 'Inter', sans-serif;
        }
        
        h1, h2, h3, h4, h5, h6 {
          font-family: 'Lora', serif;
        }
      `}</style>

      <main className="overflow-hidden" data-id="element-2">
        <HeroSection data-id="element-3" />

        <div className="relative" data-id="element-4">
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30 pointer-events-none" data-id="element-5">
            <div className="absolute top-[10%] -left-[10%] w-[50%] h-[50%] bg-[#E8DDD0] rounded-full blur-[120px]" data-id="element-6" />
            <div className="absolute bottom-[10%] -right-[10%] w-[50%] h-[50%] bg-[#8BAA8B] rounded-full blur-[120px]" data-id="element-7" />
          </div>

          <ProblemSections data-id="element-8" />
          <SolutionSections data-id="element-9" />
        </div>

        <Testimonials data-id="element-10" />
        <PricingCTA data-id="element-11" />
        <Footer data-id="element-12" />
      </main>
    </div>;
}